import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageSenderBasicInfo } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageSenderBasicInfo';
import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageSenderSocial } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageSenderSocial';

/**
 * 발신자 정보
 */
export type ChatRoomListResponsePageAllOfThreeContentItemLastMessageSender = {
  /** 사용자 기본 정보 */
  basicInfo: ChatRoomListResponsePageAllOfThreeContentItemLastMessageSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatRoomListResponsePageAllOfThreeContentItemLastMessageSenderSocial;
};
